/* eslint-disable no-tabs */
import React from 'react';
import fetch from 'node-fetch';
import { PayPalButtons } from '@paypal/react-paypal-js';
import { useAddToCart } from '@thd-olt-component-react/cart-common-data';
import { fetchPaypalToken } from '../utils/paypalUtils';
import { logAnalytics, PAYPAL_EVENTS } from '../utils/AnalyticsHelper';

export function PaypalSmartButton(orderId, payInFour, hasSavedPaypal, cartRequest, itemCount, fromPage, ffm) {
  const [addToCart] = useAddToCart();
  const buttonStyle = {
    label: hasSavedPaypal ? 'paypal' : 'checkout',
    color: 'gold',
    shape: 'rect',
    height: 40
  };

  const onApprove = (paypalData) => {
    try {
      const payPalReviewUrl = '/mycheckout/checkout?orderId=' + orderId
        + '&navigation=expressPaypal&token=' + paypalData?.orderID
        + '&PayerID=' + paypalData?.payerID;
      window.top.location.href = payPalReviewUrl;
    } catch (error) {
      console.log('Paypal on approve error: ' + error);
    }
  };

  const createOrder = (cartId) => {
    const eventName = (hasSavedPaypal && payInFour) ? PAYPAL_EVENTS.PAYPAL_PAY_LATER : PAYPAL_EVENTS.PAYPAL_SUBMISSION;
    logAnalytics({ eventName });
    return fetch(fetchPaypalToken(typeof cartId === 'string' ? cartId : orderId, fromPage, itemCount, ffm))
      .then((response) => response.json())
      .then((response) => {
        if (response?.checkoutModel?.paypalModel) {
          return response.checkoutModel.paypalModel.token;
        }
        return null;
      }).catch((error) => {
        console.log('Paypal create order error: ' + error);
      });
  };

  const addTocart = () => {
    return addToCart({ cartRequest }).then((resp) => {
      if (resp?.data?.addToCart) {
        return resp?.data?.addToCart?.cartId;
      }
      return false;
    }).then((cartId) => {
      if (cartId) {
        return createOrder(cartId);
      }
      return false;
    }).catch((error) => {
      console.log(error);
    });
  };

  return (
    <PayPalButtons
      createOrder={cartRequest ? addTocart : createOrder}
      onApprove={onApprove}
      fundingSource={(hasSavedPaypal && payInFour) ? 'paylater' : 'paypal'}
      style={buttonStyle}
    />
  );
}